import { writable } from 'svelte/store';
import {push} from './pt-router/Router.svelte'

export const ITEM_VIEW_ID = 0;
export const ADD_ITEM_VIEW_ID = 1;
export const LOGIN_VIEW_ID = 2;
export const USER_VIEW_ID = 3;

export const ITEMTYPE_NEWS = 0;
export const ITEMTYPE_SUGGESTION = 1;
export const ITEMTYPE_PRAISE = 2;
export const ITEMTYPE_CRITICISM = 3;
export const ITEMTYPE_MISC = 4;

export const ITEMTYPE_NOTICE = 1000;
export const ITEMTYPE_ANNOUNCEMENT = 1001;
export const ITEMTYPE_QUESTION = 1002;
export const ITEMTYPE_POLL = 1003;

export const REPORTTYPE_ITEM = 0;
export const REPORTTYPE_COMMENT = 1;
export const REPORTTYPE_USER = 2;

export const ReportReviewDecision_Ignore = 0
export const ReportReviewDecision_Delete = 1
export const ReportReviewDecision_Ban    = 2

export const NOTIFICATION_TYPE_ITEM = 0;
export const NOTIFICATION_TYPE_COMMENT = 1;
export const NOTIFICATION_TYPE_OFFICALSAWITEM = 2;
export const NOTIFICATION_TYPE_ITEMLIKE = 3;
export const NOTIFICATION_TYPE_COMMENTLIKE = 4;

export const USER_REGISTRATION_EMAIL = 0;
export const USER_REGISTRATION_GOOGLE = 1;

export const FEEDTYPE_ITEM = 0;
export const FEEDTYPE_COMMENT = 1;

export const ShadowBanReason_BannedIP     = 1
export const ShadowBanReason_UserValue    = 2
export const ShadowBanReason_ItemValue    = 3
export const ShadowBanReason_CommentValue = 4

export const UnscreenedContent_Item = 1
export const UnscreenedContent_Comment = 2

export const SECONDS_IN_A_MINUTE = 60;
export const SECONDS_IN_AN_HOUR = SECONDS_IN_A_MINUTE * 60;
export const SECONDS_IN_A_DAY = SECONDS_IN_AN_HOUR * 24;

export const currentUser = writable(undefined);
export let currentUserValue
const unsubsribe = currentUser.subscribe(value => {
    currentUserValue = value
})

const CACHE_INVALID_PERIOD = 200000;

export function resetCurrentUserValue() {
    currentUserValue = undefined
}

export function updateLoggedInUser(after) {
    if(currentUserValue || currentUserValue === false) {
        after()
        return
    }

    fetch(
        'API_URL/session',
        {
            method: "GET",
            headers: new Headers({'content-type': 'application/json'}),
            credentials: 'include'
        }
    )
    .then(r => {
        if(r.status == 200) {
            return r.json()
        } else {
            currentUser.update(n => false)
            if(!localStorage.getItem("welcome-notifs")) {
                CreateNotification({body: "Welcome to Plan Together!"}, 1000, 10000)

                CreateNotification({body: `
                    A Collaborative Map Platform enabling Citizens, Planning Enthusiasts and Municipal Planners to talk, plan and learn about their communities.
                `}, 3000, 8000)

                CreateNotification({body: "Check out what others have contributed!"}, 7000, 4000)
                localStorage.setItem("welcome-notifs", "true")
            }
        }
    })
    .then(u => {
        currentUser.update(n => u)
        currentUserValue = u
        if(after)
            after()
    })
}

export function logUserOut() {
    if(currentUserValue.user_registration == USER_REGISTRATION_GOOGLE) {
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
        });
    }

    currentUser.update(n => false)
    fetch(
    'API_URL/session',
    {
        method: "DELETE",
        headers: new Headers({'content-type': 'application/json'}),
        credentials: 'include'
    })
    .then(r => {
        if(r.status == 200) {
            return;
        }
    })

    push('/')
}

export function getData(id) {
    return fetch(
    'API_URL/' + id,
    {
        method: "GET",
        headers: new Headers({'content-type': 'application/json'}),
        credentials: "include"
    })
    .then(r => {
        if(r.ok) {
            return r.json()
        }
        console.log("Problem getting data:", r)
        return new Promise((y,n) => {
            y(null)
        })
    })
}

export function postData(id, body) {
    return sendNetworkData('POST', id, body)
}

export function putData(id, body) {
    return sendNetworkData('PUT', id, body)
}

export function deleteData(id, body) {
    return sendNetworkData('DELETE', id, body)
}

function sendNetworkData(method, id, body) {
    console.log(method, id, body)
    return fetch(
    'API_URL/' + id,
    {
        method: method,
        body: JSON.stringify(body),
        headers: new Headers({'content-type': 'application/json'}),
        credentials: "include"
    })
    .then(r => {
        if(r.ok) {
            return r.json()
            .then(data => {
                return new Promise((y,n) => {
                    y({ok: true, data: data})
                })
            })
        }

        console.log(r)

        return new Promise((y,n) => {
            y({ok: false, code: r.status})
        })
    })
    .catch(r => {
        console.log(r)

        return new Promise((y,n) => {
            y({ok: false, data: null})
        })
    })
}

export function isMobile() {
    if(window.innerWidth <= 972) {
        return true;
    } else {
        return false;
    }
}

export const notifications = writable([]);
export function CreateNotification(n, delay, length) {
    setTimeout(() => {
        notifications.update(curr => curr.concat(n))
    }, delay)

    let displayTime = length ? length : 5000;
    setTimeout(() => {
        notifications.update(curr => curr.filter(e => e != n))
    }, delay + displayTime)
}

export function NotifyNewItemBadges(user) {
    if(user.user_itemcount == 1) {
        CreateNotification({body: "Your first item! You've earned the Starter badge!", img: "/badges/badge_item_1.png"}, 1000)
    } else if(user.user_itemcount == 10) {
        CreateNotification({body: "That's 10 items! You've earned the Architect badge!", img: "/badges/badge_item_2.png"}, 1000)
    } else if(user.user_itemcount == 100) {
        CreateNotification({body: "Woah, 100 items! You've earned the Statesman badge!", img: "badges/badge_item_3.png"}, 1000)
    }
}

export function NotifyNewCommentBadges(user) {
    if(user.user_commentcount == 1) {
        CreateNotification({body: "Your first comment! You've earned the Non-by-stander badge!", img: "/badges/badge_comment_1.png"}, 1000)
    } else if(user.user_commentcount == 10) {
        CreateNotification({body: "That's 10 comments! You've earned the Snapbacker badge!", img: "/badges/badge_comment_2.png"}, 1000)
    } else if(user.user_commentcount == 100) {
        CreateNotification({body: "100 comments, amazing! You've earned the Big Mouth badge!", img: "/badges/badge_comment_3.png"}, 1000)
    }
}

export function NotifyNewLikeBadges(user) {
    if(user.user_likecount == 1) {
        CreateNotification({body: "Your first item like! You've earned the Likie badge!", img: "/badges/badge_prop_1.png"}, 1000)
    } else if(user.user_likecount == 10) {
        CreateNotification({body: "That's 10 item likes! You've earned the Likester badge!", img: "/badges/badge_prop_2.png"}, 1000)
    } else if(user.user_likecount == 100) {
        CreateNotification({body: "100 item likes total! You've earned the Likezilla badge!", img: "/badges/badge_prop_3.png"}, 1000)
    }
}

export const loginContext = writable(false);

export function sanitizeContent(str) {
    return str
    //.replace(/</g, '&lt;')
    //.replace(/>/g, '&gt;')
    .replace('IMG_URL/', 'https://ik.imagekit.io/plantogether/')
    .replace(/\n/g, "<br>")
    .replace(/\[([^\]]*)\]/g, '<a href="$1">$1</a>')
    .replace(/\{([^\]]*)\}/g, '<img style="width: 100%; border-radius: 10px; margin-top: 5px; margin-bottom: 5px" src="API_URL/image/$1">')
}

export function ReplaceImagesIfNeeded(htmlString) {
    return htmlString.replace(/<img\s[^>]*?src\s*=\s*['\"]([^'\"]*?)['\"][^>]*?>/g,
    `<div class="unscreened-image" style="cursor: pointer;text-align: center; font-style: italic; color: grey; background-color: rgb(235, 235, 243); margin-top: 10px; margin-bottom: 10px; padding: 10px; padding-top: 20px; padding-bottom: 20px; border-radius: 10px">Attached Image Visible After Approval</div>`)
}

export function RemoveImagesIfNeeded(htmlString) {
    return htmlString.replace(/<img\s[^>]*?src\s*=\s*['\"]([^'\"]*?)['\"][^>]*?>/g, '')
}

export function shredRichContent(str) {
    return str
    //.replace(/</g, '&lt;')
    //.replace(/>/g, '&gt;')
    .replace('IMG_URL/', 'https://ik.imagekit.io/plantogether/')
    .replace(/\n/g, ' ')
    .replace(/\{([^\]]*)\}/g, '<img style="width: 100%; border-radius: 10px; margin-top: 5px; margin-bottom: 5px" src="API_URL/image/$1">')
    .replace(/\[(.*)\]/g, ' $1 ')
}

export function inEnabledArea(point, areas) {
    for(let i in areas) {
        if((areas[i].second_latitude <= point.latitude && point.latitude <= areas[i].first_latitude) &&
        (areas[i].first_longitude <= point.longitude && point.longitude <= areas[i].second_longitude)) {
            return true
        }
    }
    return false
}

export function UnixTimeToDateStr(point) {
    return new Date(point * 1000).toLocaleDateString("en-US") + ' ' +
        new Date(point * 1000).toLocaleTimeString("en-US")
}

export function UnixTimeToDateOnlyStr(point) {
    return new Date(point * 1000).toLocaleDateString("en-US");
}

export class LeafletLRU {
    constructor(max=10, evictFunc) {
        this.max = max;
        this.cache = new Map();
        this.evictFunc = evictFunc
    }

    get(key) {
        let item = this.cache.get(key);
        if (item) // refresh key
        {
            this.cache.delete(key);
            this.cache.set(key, item);
        }
        return item;
    }

    set(key, val) {
        if (this.cache.has(key)) { // refresh key
            this.cache.delete(key);
        }
        else if (this.cache.size == this.max) { // evict oldest
            this.evictFunc(this._firstValue())
            this.cache.delete(this._firstKey());
        }
        this.cache.set(key, val);
    }

    _firstKey(){
        return this.cache.keys().next().value;
    }

    _firstValue(){
        return this.cache.values().next().value
    }
}

export function getSpecialStr(id) {
    switch(id) {
        case 1:
            return 'Community Coordinator';
        default:
            return '';
    }
}

export function isValidEmail(value) {
    const atLocation = value.lastIndexOf("@");
    const dotLocation = value.lastIndexOf("."); 
    return (
        atLocation > 0 &&
        dotLocation > atLocation + 1 &&
        dotLocation < value.length - 1
    );
};

let cachedFeed = {}
export function getCachedFeed(name) {
    return cachedFeed[name]
}
export function setCachedFeed(name, newFeed) {
    cachedFeed[name] = newFeed
}
export function clearCachedFeed(name) {
    cachedFeed[name] = null
}

export function trylikeItem(item_id, push, successFunc) {
    if(!currentUserValue) {
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        loginContext.update(v => "item/" + item_id)
        push('/login')
        return;
    }
    fetch(
        'API_URL/item/like/' + item_id,
        {
            method: "POST",
            headers: new Headers({'content-type': 'application/json'}),
            credentials: "include"
        }
    ).then(r => {
        if(r.status == 208) {
            alert("You can only like an item once!");
            return;
        } else if(r.status != 200) {
            alert("Problem sending like!")
            return;
        }
        currentUser.update(c => {
            c.user_likecount += 1;
            return c
        })
        CreateNotification({body: "Thanks for the like!"}, 1000)
        NotifyNewLikeBadges(currentUserValue);

        if(successFunc) {
            successFunc()
        }
    })
}

export function addCommentToItem(item, newComment, successFunc) {
    newComment.item_id = item.id;
    newComment.user_id = currentUserValue.user_id
    newComment.user = currentUserValue
    postData('comment', newComment)
    .then(r => {
        if(!r.ok) {
            alert("Problem adding Comment. Please try again.")
            return
        }

        currentUser.update(c => {
            c.user_commentcount += 1;
            return c
        })
        
        CreateNotification({body: "Thank you for the comment!"}, 1000)
        NotifyNewCommentBadges(currentUser)
        
        if(successFunc) {
            successFunc()
        }
    })
}

export function getItemTypeString(id) {
    switch(id) {
        case ITEMTYPE_NEWS:
            return "News"
        case ITEMTYPE_SUGGESTION:
            return "Suggestion"
        case ITEMTYPE_PRAISE:
            return "Praise"
        case ITEMTYPE_CRITICISM:
            return "Criticism"
        case ITEMTYPE_MISC:
            return "Misc."
        case ITEMTYPE_NOTICE:
            return "Official Notice"
        case ITEMTYPE_ANNOUNCEMENT:
            return "Official Announcement"
        case ITEMTYPE_QUESTION:
            return "Official Question"
        case ITEMTYPE_POLL:
            return "Official Poll"
        default:
            return "Item"
    }
}

export function getItemTypeColorString(id) {
    switch(id) {
        case ITEMTYPE_NEWS:
            return "rgb(196, 127, 0)"
        case ITEMTYPE_SUGGESTION:
            return "#0676cd"
        case ITEMTYPE_PRAISE:
            return "rgb(36, 185, 36)"
        case ITEMTYPE_CRITICISM:
            return "rgb(163, 0, 0)"
        case ITEMTYPE_MISC:
            return "#6f24a9"
        case ITEMTYPE_NOTICE:
            return "black"
        case ITEMTYPE_ANNOUNCEMENT:
            return "black"
        case ITEMTYPE_QUESTION:
            return "black"
        case ITEMTYPE_POLL:
            return "black"
        default:
            return "grey"
    }
}

export function stripHtml(html) {
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}

export function addCommentToComment(comment, newComment, successFunc) {
    newComment.item_id = comment.item_id
    newComment.user_id = currentUserValue.user_id
    newComment.user = currentUserValue
    newComment.parent_id = comment.id
    postData('comment',newComment)
    .then(r => {
        if(!r.ok) {
            alert("Problem adding Comment. Please try again.")
            return
        }

        currentUser.update(c => {
            c.user_commentcount += 1;
            return c
        })
        
        CreateNotification({body: "Thank you for the comment!"}, 1000)
        NotifyNewCommentBadges(currentUser)

        if(successFunc) {
            successFunc(r.data)
        }
    })
}

export function trylikeComment(commentId, successFunc) {
    postData('comment/like/' + commentId)
    .then(r => {
        if(!r.ok) {
            console.log("R:", r)
            if(r.code == 406) {
                alert("You can only like a comment once!");
                return;    
            } else {
                alert("Problem sending like!")
                return;
            }
        }
        successFunc()
    })
}

export function isMunicipalItem(item_type) {
    return 1000 <= item_type;
}

let afterLogin = null
export function getAfterLogin() {
    return afterLogin
}
export function setafterLogin(newAfterLogin) {
    afterLogin = newAfterLogin
}
export function clearAfterLogin() {
    afterLogin = null
}